<template>
  <div class="startpage">
    <BtDevOnly>
      <div
        v-if="data"
        class="debug-config"
      >
        {{ data }}
      </div>
    </BtDevOnly>
    <div
      class="startpage-frame"
    >
      <StartpageSkeletonDefault />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ProvideNames } from '#shared/statics';

interface StartpageConfig {
  layout: 'Simple' | 'Compact' | 'Balanced';
}
const store = ref(ProvideNames.DEFAULT_CENTRAL_STORE.id)
const { data } = await useFetch<StartpageConfig>(
  () => (import.meta.client ? useRuntimeConfig()?.public?.apiUrl : '') + '/api/nea/startpage-service',
  {
    // key: 'startpageConfig-' + store?.value,
    baseURL: useRuntimeConfig().public.localDevelopment ? 'https://staging.brntgs.expert.de' : undefined,
    params: {
      store: store?.value
    },
  },
);

onNuxtReady(initializeStore)

provide('startpageConfig', data);

watch(useCurrentStore(), () => {
  if (useCurrentStore()?.value?.id != ProvideNames.DEFAULT_CENTRAL_STORE.id) {
    navigateTo(
      {
        path: useCurrentStore()?.value?.storeLink,
        query: useRoute()?.query,
      },
      {
        external: true,
      },
    );
  }
}, {
  immediate: true
});

useHead({
  title: 'Elektromarkt in Ihrer Nähe mit Online-Shop',
  meta: [
    {
      name: 'description',
      content:
        'Finden Sie hier Ihren expert Elektrofachmarkt in Ihrer Nähe und viele Aktionsangebote ✔ günstig im expert Online-Shop. expert – Mit den besten Empfehlungen.',
    },
    { property: 'pagetype', content: 'Start' },
  ],
});
</script>
<style lang="postcss" scoped>
.startpage {
  @apply bg-secondary;
  min-height: 900px;
}
.startpage-frame {
  @apply lg:container mx-auto p-4 lg:px-0 lg:pb-20 pt-4 flex flex-col gap-14 max-w-full;
}
</style>
